import { CSSProperties } from '@material-ui/styles'

export const DRAWER_WIDTH = '240px'
export const COLOR = {
  CLEAR: 'rgba(0,0,0,0)',
  CLEAR_BLACK: 'rgba(0,0,0,0.85)',
  TITLE_BLUE: 'rgb(16,16,48)',
  PHOTO_TITLE: 'rgb(245,255,250)',
  CONTENT: 'rgb(0,0,32)',
  LINK_HOVER: 'rgb(0,128,0)',
  CONTENT_BORDER_BOTTOM: 'rgba(60,60,60,0.2)',
  APP_BAR_BACKGROUND: 'rgba(178,34,34,1)',
  CONTENT_BACKGROUND: 'rgba(255,255,255,0.2)',
}
export const FONT = {
  GOTHIC: 'Yu Gothic',
  MINCHO: 'Yu Mincho',
}
export const SIZE = {
  MAIN_TITLE: 75,
  SUB_TITLE: 35,
  CONTENT_TITLE: 50,
  PHOTO_TITLE: 16,
  CONTENT_SMALL: 16,
  CONTENT_LARGE: 24,
}
export const MARGIN = {
  CONTENT: '0px 10px 70px',
}
export const Style = {
  configTitle: (fontSize: number, backgroundColor: string): CSSProperties => {
    return {
      fontFamily: FONT.MINCHO,
      fontSize,
      fontWeight: 'bold',
      margin: '10px 20px',
      padding: '0px 20px',
      color: COLOR.TITLE_BLUE,
      backgroundColor,
    }
  },
}
